import axios from 'axios'
import config from 'config'
import { getAccessToken } from 'utils/authToken'

function createAxiosInstance(baseURL, useAuth = false, uploadForm = false) {
  const instance = axios.create({
    baseURL,
    timeout: 60000 * 2 // 2 minutes
  })

  instance.interceptors.request.use(
    async (config) => {
      if (!config.headers) config.headers = {}

      if (useAuth) {
        const token = getAccessToken()
        if (token) config.headers.Authorization = `Bearer ${token}`
      }

      if (uploadForm) {
        config.headers = {
          ...config.headers,
          'Content-Type': 'multipart/form-data'
        }
      }

      return config
    },
    (error) => Promise.reject(error)
  )

  instance.interceptors.response.use(
    (response) => response.data,
    (error) => {
      if (!error.response) return Promise.reject(error)
      return Promise.reject(error)
    }
  )

  return instance
}
export const uploadFormRequest = createAxiosInstance(config.mainBackendUrl, true, true)
export const backendRequest = createAxiosInstance(config.mainBackendUrl, true)
export const stacRequest = createAxiosInstance(config.stacBackendurl)
export const regionBoundaryRequest = createAxiosInstance(config.regionBoundaryUrl)
export const assetRequest = createAxiosInstance(config.authUrl)
